import { Firmware } from 'src/models/firmware';
import { Organization } from 'src/models/organization';

export const getOrgName = (orgId?: string, orgs?: Organization[]) => {
  if (!orgId || !orgs) {
    return 'Unknown';
  }

  const org = orgs.find(org => org._id === orgId);
  return org?.orgName ?? 'Unknown';
};

export const getFirmwareVersion = (firmwareId: string, firmwares: Firmware[]) => {
  const firmware = firmwares.find(firmware => firmware._id === firmwareId);
  return firmware?.version ? firmware.version : 'Unknown';
};

/**
 * If existing, finds the firmware with the provided firmware version and returns its id.
 *
 * @param firmwareVersion The fw version used to check if there are any matching firmwares.
 * @param firmwares The firmware records.
 */
export const getFirmwareId = (firmwareVersion: string | undefined, firmwares: Firmware[]) => {
  if (!firmwareVersion) return undefined;
  const firmware = firmwares.find(firmware => firmware.version.includes(firmwareVersion));
  return firmware?._id ? firmware._id : firmwareVersion;
};

/**
 * Takes the timestamp parameter and returns a formatted date string.
 *
 * @param epochTime The Unix timestamp.
 * @param timezone
 */
export const getDate = (epochTime: number, timezone = 'UTC') => {
  if (!epochTime) {
    return '';
  }
  const formatter = new Intl.DateTimeFormat(undefined, { timeZone: timezone, dateStyle: 'medium' });
  return formatter.format(epochTime);
};
